import { Form, Formik } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../../constants';
import { signUpSchema } from '../../../schema/sign-up.schema';
import { SubmitForm } from '../../../utils/submit-form.util';
import Button from '../../button/v2/button';
import { HStack, VStack } from '../../layouts/stack.layout';
import { initialSignUpFormValues } from './constants';
import AccountAuth from './sign-up-steps/account-auth.step';
import AccountDetails from './sign-up-steps/account-details.step';
import PersonalDetails from './sign-up-steps/personal-details.step';
import { STEP } from './sign-up-steps/steps';
import {
  hasNextStep,
  hasPreviousStep,
  verifyStepDetails,
} from './sign-up-steps/utils';

export default function SignUpForm() {
  const lastStep = Object.keys(STEP).length;
  const [currentStep, setCurrentStep] = useState<number>(STEP.ACCOUNT_DETAILS);
  const navigate = useNavigate();

  const nextStep = () => {
    setCurrentStep((prev) => {
      if (prev !== 3) return prev + 1;
      else return prev;
    });
  };

  const prevStep = () => {
    setCurrentStep((prev) => {
      if (prev !== 1) return prev - 1;
      else return prev;
    });
  };

  return (
    <Formik
      initialValues={initialSignUpFormValues}
      validationSchema={signUpSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        await SubmitForm.signUpForm(values, setSubmitting);
        navigate(PATH.HOME);
      }}
    >
      {(formik) => (
        <Form className="w-full">
          <VStack gap="base" extensions="w-full">
            <HStack extensions="bg-[#171718] relative w-full mobile:px-3 mobile:py-10 tablet-sm:px-6 tablet-sm:py-16 rounded-lg">
              {currentStep === STEP.ACCOUNT_DETAILS && (
                <AccountDetails username={formik.values.username} />
              )}
              {currentStep === STEP.ACCOUNT_AUTH && (
                <AccountAuth username={formik.values.username} />
              )}
              {currentStep === STEP.PERSONAL_DETAILS && (
                <PersonalDetails username={formik.values.username} />
              )}
            </HStack>
            <HStack extensions="w-full" gap="base" justify="center">
              <Button
                type="button"
                disabled={!hasPreviousStep(currentStep, lastStep)}
                text="Previous"
                onClick={prevStep}
              />
              <Button
                type={currentStep === lastStep ? 'submit' : 'button'}
                disabled={
                  verifyStepDetails(
                    formik.touched,
                    formik.errors,
                    currentStep
                  ) && hasNextStep(currentStep, lastStep)
                }
                color="secondary"
                text={currentStep === lastStep ? 'create account' : 'next'}
                onClick={nextStep}
              />
            </HStack>
          </VStack>
        </Form>
      )}
    </Formik>
  );
}
